import { render, staticRenderFns } from "./staticFullscreenCard.vue?vue&type=template&id=290874e1&"
import script from "./staticFullscreenCard.vue?vue&type=script&lang=js&"
export * from "./staticFullscreenCard.vue?vue&type=script&lang=js&"
import style0 from "./staticFullscreenCard.vue?vue&type=style&index=0&id=290874e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports